import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="announcement-modal"
export default class extends Controller {
  static values = {
    announcements: Array
  }

  connect() {
    console.log('Announcement controller connected, announcements:', this.announcementsValue)
    console.log('window.bootstrap:', window.bootstrap, 'Modal available:', window.bootstrap?.Modal)
    if (this.announcementsValue.length > 0) {
      this.currentIndex = 0
      this.showModal(this.currentIndex)
    }
  }

  showModal(index) {
    if (index < 0 || index >= this.announcementsValue.length) return
    this.currentIndex = index
    const announcement = this.announcementsValue[index]
    console.log('Attempting to show modal for announcement ID:', announcement.id)
    const modalElement = document.getElementById('imageModal_' + announcement.id)
    console.log('Modal element found:', modalElement)
    if (modalElement && window.bootstrap && window.bootstrap.Modal) {
      this.modal = new window.bootstrap.Modal(modalElement)
      this.modal.show()
    } else {
      console.error('Modal element not found or Bootstrap not available for announcement:', announcement.id)
    }
  }

  prev() {
    const newIndex = this.currentIndex - 1
    if (newIndex >= 0) {
      if (this.modal) this.modal.hide()
      this.showModal(newIndex)
    }
  }

  next() {
    const newIndex = this.currentIndex + 1
    if (newIndex < this.announcementsValue.length) {
      if (this.modal) this.modal.hide()
      this.showModal(newIndex)
    }
  }
}